import React from 'react';

class LightrailPurchase extends React.Component {
  componentDidMount() {
    if (this.container && this.props.shopperToken) {
      const scriptTag = document.createElement('script');
      scriptTag.src = 'https://embed.lightrail.com/dropin/cardPurchase.js';
      scriptTag.setAttribute('data-shoppertoken', this.props.shopperToken);
      this.container.appendChild(scriptTag);
    }
  }

  render() {
    return (
      <div className="lightrail" ref={div => (this.container = div)}>
        {!this.props.shopperToken && (
          <button className="btn-primary" onClick={this.props.login}>
            Buy a Gift Card
          </button>
        )}
      </div>
    );
  }
}

export default LightrailPurchase;



// WEBPACK FOOTER //
// ./shared/components/gifting/lightrail.js